import RUC from '@/utils/Ruc';
import * as types from '@/store/mutation-types';

export default {
    name: 'Confirm',
    props: {
        index: Number,
        mode: String,
        type: String,
    },
    components: {
    },
    data() {
        return {
            displaypassword: '',
            enterPassword: '',
            remember: false,
            passwordType: 'text',
        };
    },
    watch: {
    },
    created() {
        window.realpassword = [];

        (function (d) { var b = []; var a = {}; var g = []; var c = []; var e = []; var f = {}; Array.prototype.insert = function (h, i) { this.splice(h, 0, i) }; f.passwordListener = function (i, h) { var j = (h.passwordField === "") ? ".disabledAutoFillPassword" : h.passwordField; if (i.find("[type=password]").length > 0) { i.find("[type=password]").attr("type", "text").addClass("disabledAutoFillPassword") } i.on("keyup", j, function () { if (!this.id) { this.id = Math.random().toString(36).substring(5) } if (!g.hasOwnProperty(this.id)) { g[this.id] = [] } var m = g[this.id]; c[this.id] = d(this).val(); var p = c[this.id]; e[this.id] = p.length; var l = e[this.id]; var k = this.selectionStart; for (var o = 0; o < l; o++) { if (p[o] !== h.hidingChar) { m[o] = p[o] } } if (l < m.length) { var q = m.length - l; var n = event.keyCode || event.charCode; if (n == 8 || n == 46) { m.splice(k, q) } else { m.splice(k - 1, q + 1); m.insert(k - 1, p[k - 1]) } } d(this).val(p.replace(/./g, h.hidingChar)); window.realpassword = m; if (h.debugMode) { console.log("Current keyup position: " + k); console.log("Password length: " + l); console.log("Real password:"); console.log(m) } }) }; f.formSubmitListener = function (i, h) { var j = (h.submitButton == "") ? ".disableAutoFillSubmit" : h.submitButton; i.on("click", j, function (k) { f.restoreInput(i, h); if (h.callback.call()) { if (h.debugMode) { console.log(i.serialize()) } else { if (h.html5FormValidate) { d(j).attr("type", "submit").trigger("submit"); setTimeout(function () { d(j).attr("type", "button") }, 1000) } else { i.submit() } } } }) }; f.randomizeInput = function (i, h) { i.find("input").each(function (k) { b[k] = d(this).attr("name"); if (a[b[k]]) { d(this).attr("name", a[b[k]]) } else { var j = Math.random().toString(36).replace(/[^a-z]+/g, ""); d(this).attr("name", j); a[b[k]] = j } }) }; f.restoreInput = function (i, h) { if (h.randomizeInputName) { i.find("input").each(function (j) { d(this).attr("name", b[j]) }) } if (h.textToPassword) { i.find(h.passwordField).attr("type", "password") } i.find(h.passwordField).each(function (j) { d(this).val(g[this.id].join("")) }) }; d.fn.disableAutoFill = function (h) { var i = d.extend({}, d.fn.disableAutoFill.defaults, h); this.attr("autocomplete", "off"); if (this.find("[type=submit]").length > 0) { this.find("[type=submit]").addClass("disableAutoFillSubmit").attr("type", "button") } if (i.submitButton != "") { this.find(i.submitButton).addClass("disableAutoFillSubmit").attr("type", "button") } if (i.randomizeInputName) { f.randomizeInput(this, i) } f.passwordListener(this, i); f.formSubmitListener(this, i) }; d.fn.disableAutoFill.defaults = { debugMode: false, textToPassword: true, randomizeInputName: true, passwordField: "", hidingChar: "●", html5FormValidate: false, submitButton: "", callback: function () { return true }, } })(jQuery); 
        setTimeout(() => {
            $('#login-form').disableAutoFill({
                passwordField: '.password',
            });
        }, 300);

    },
    mounted() { },
    methods: {
        changeInputType() {
            // this.passwordType = 'password';
        },
        enterPasswordAction(val) {
            console.log(val);
        },
        confirmDownLoad() {
            const self = this;
            self.enterPassword = window.realpassword.join('');
            if (self.enterPassword) {
                const accountList = self.$store.state.accountList;
                const account = accountList[self.index];
                RUC.getMnemonic(account, self.enterPassword, self.remember).then((res) => {
                    if (res.code !== 0) {
                        self.$Message.error(self.$t(res.errmsg));
                    }
                    if (self.mode === 'withdraw') {
                        self.$emit('confirmAction', {
                            code: 0,
                            password: self.enterPassword,
                        });
                        return false;
                    }
                    if (self.mode === 'transfer') {
                        self.$emit('confirmTransferAction', {
                            code: 0,
                            password: self.enterPassword,
                        });
                        return false;
                    }
                    if (self.type === 'cancelOrder') {
                        self.$emit('callCancelOrder', {
                            code: 0,
                            password: self.enterPassword,
                        });
                        return false;
                    }
                    let mnemonic = res.mnemonic;
                    const privateKey = res.privateKey;
                    mnemonic = `${mnemonic} ${account.userid}`;
                    if (self.mode === 'trade') {
                        self.$emit('passCreateOrder', {
                            type: self.type,
                            password: self.enterPassword,
                        });
                    } else {
                        const link = document.createElement('a');
                        link.download = `mnemonic-${account.userid}.txt`;
                        mnemonic = `${mnemonic}\n${privateKey}`;
                        const data = new Blob([mnemonic], {
                            type: 'text/plain',
                        });
                        link.href = window.URL.createObjectURL(data);
                        document.body.appendChild(link);
                        link.click();
                        self.$emit('hideExportDialog', '');
                        if (self.mode == 'logout') {
                            self.$store.commit(types.SET_ACCOUNT_LIST, self.$store.state.accountList.filter((item, index) => {
                                return index != self.$store.state.currAccountIndex;
                            }));
                            self.$store.commit(types.SELECT_ACCOUNT, 0);
                            self.$emit('hideLogoutDialog', '');
                            self.$Message.success(self.$t('success'));
                        }
                    }
                }).catch((e) => {
                    console.log(e);
                    self.$Message.error(self.$t(e.errmsg));
                });
            } else {
                self.$Message.error(self.$t('account_input_the_password'));
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/common/confirm.js